import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video_top",
  "use": "icon-video_top-usage",
  "viewBox": "0 0 12.095 14.688",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.095 14.688\" id=\"icon-video_top\">\n  <path id=\"icon-video_top_取消置顶\" d=\"M103.322,2.016l-5.8,5.8,1.054,1.054,4-4v9.824h1.491V4.875l3.993,3.992,1.053-1.054-5.046-5.046V2.762h-.005l-.746-.746ZM97.28,0V1.44h12.1V0Z\" transform=\"translate(-97.28)\" fill=\"#505d6f\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol